// extracted by mini-css-extract-plugin
module.exports = {"word":"EmojiArt_word__2IR5o","emojiLetter":"EmojiArt_emojiLetter__3vD40","row":"EmojiArt_row__275qR","emoji":"EmojiArt_emoji__3Nnxb","empty":"EmojiArt_empty__2p8Ir"};